import React from "react"

import ProjectSession from "../../../../model2/project/project-session"
import ItemId from "../../../id/item-id"
import Pin from "../../../../gd-components/pin/v2/pin"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../gd-components/buttons/control-button/control-button-standard"
import StarProjectControl from "../../../../gd-components/star/star"
import ControlShowInProjectsTree from "../../../../gd-app/component/quick-links/aim"

type Props = {
    project         : ProjectSession
    hidePopover     : callback
}

export default function MoreProject_PopoverMenuTop(props:Props) {

    const onClickOpenNewWindow = () => {
        gd.layout.popovers.closeAll()

        props.project.openNewWindow()
    }

    const onClickCopyLink = () => {
        gd.layout.popovers.closeAll()

        props.project.copyUrl()
    }

    const refresh = () => {
        gd.layout.popovers.closeAll()
    }

    const canPinStar    = props.project.properties.availableMenuOptions.pinStar
    const canDirectLink = props.project.properties.availableMenuOptions.directLink
    const canShowInMenu = props.project.properties.availableMenuOptions.showInMenu

    return (
        <div className="flex-row-between-center h-36 m-t-5 p-l-20 p-r-10">

            <ItemId itemId={props.project.id}
                    itemUrl="p/"
                    itemUrlId={props.project.id}
                    itemName="Resource"
                    copyId={true}
                    copyUrl={false}/>

            <div className="flex-row-center-center">

                {canPinStar &&
                    <>
                        <Pin data={{projectId: props.project.id}}/>

                        <StarProjectControl project={props.project} callback={refresh} className="m-l-5" />
                    </>
                }

                {canDirectLink &&
                    <>
                        <ControlButtonStandard className    = "m-l-5"
                                               type         = {ControlButtonType.LINK}
                                               hint         = "Copy link"
                                               onClick      = {onClickCopyLink}/>

                        <ControlButtonStandard className    = "m-l-5"
                                               type         = {ControlButtonType.OPEN_IN_BROWSER}
                                               hint         = "Open in new window"
                                               onClick      = {onClickOpenNewWindow}/>
                    </>}

                {canShowInMenu &&
                    <ControlShowInProjectsTree className    = "m-l-5"
                                               project      = {props.project}/>}

            </div>
        </div>
    )


}
